import { fetchuserContextFromAPI } from "../global/_fetchUserContextFromAPI";
import { emailShareImageSetup } from "./_email";
import { registryReturnCodeMessages } from "./_registry";
import Cookies from "js-cookie";

export const allDevicesProductPageSetup = async () => {
  try {
        const response = await fetchuserContextFromAPI();
        var screenWidth = $(window).innerWidth(),
          altImageCount = $(".alt-image-list-container li").length,
          arrowsNS = $(".alt-image-nav-down,.alt-image-nav-up"),
          arrowsEW = $(".alt-image-nav-left,.alt-image-nav-right");
        $(".alt-image-list-container").height() >
        $(".alt-image-list-container ul").height()
          ? arrowsNS.hide()
          : arrowsNS.show();
        $(".alt-image-list-container").width() > altImageCount * 70 ||
        screenWidth > 992
          ? arrowsEW.hide()
          : arrowsEW.show();

        if (
          Cookies.get("attemptToAddToWL") != undefined &&
          Cookies.get("addToWishListResponse") != undefined
        ) {
          if (Cookies.get("attemptToAddToWL")) {
            var addedToWishListDivSelector =
              "#" + Cookies.get("attemptToAddToWL");
            if ($(addedToWishListDivSelector).length > 0) {
              $(addedToWishListDivSelector)
                .parent()
                .prepend(
                  decodeURIComponent(Cookies.get("addToWishListResponse"))
                );
              Cookies.set("attemptToAddToWL", "", {
                path: "/",
                expires: -1,
              });
              Cookies.set("addToWishListResponse", "", {
                path: "/",
                expires: -1,
              });
              Cookies.set("addToWishListItemsAdded", "", {
                path: "/",
                expires: -1,
              });
            }
          }
        }
        //this is used when the user has been redirected to logon when attempting to add to registry
        if (
          Cookies.get("attemptToAddToReg") != undefined &&
          Cookies.get("userInfo") != undefined &&
          response.basicInfo.callerId != -1002 && response.isPartiallyAuthenticated == false
        ) {
          var addedToRegistryValue = Cookies.get("attemptToAddToReg");
          var form = addedToRegistryValue.substr(
            0,
            addedToRegistryValue.indexOf(";")
          );
          var attributes = addedToRegistryValue.substr(
            addedToRegistryValue.indexOf(";") + 1
          );
          if (attributes.length > 0) {
            var array = attributes.split("|");
            $.each(array, function (i) {
              var attribute = array[i].split(":")[0];
              var attrvalue = array[i].split(":")[1];
              $("#" + form)
                .find("#" + attribute)
                .val(attrvalue);
            });
          }

          $("#" + form)
            .find(".add-to-registry")
            .click();

          Cookies.set("attemptToAddToReg", "", {
            path: "/",
            expires: -1,
          });
        }

        emailShareImageSetup();
        registryReturnCodeMessages();
  } catch (e) {
    console.log(e);
  }
};
